import request from "../request"


export function getFlightAircraftCount() {
  return request.get({
    url: "/fly_plan/staticCount"
  })
}
export function getWarningInfo(params) {
  return request.get({
    url: "/warning_info/get_warning_info",
    params: params
  })
}
export function getFlightVehicleTableData(params) {
  return request.get({
    url: "/fly_plan/homepage",
    params: params
  })
}